export default "__VITE_ASSET__2dc94536__"